import {inject, Injectable} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {ComponentType} from '@angular/cdk/portal';
import {ExceptionDialogComponent} from '../components/exception-dialog/exception-dialog.component';
import {LoadingSpinnerService} from './loading-spinner.service';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  readonly dialog = inject(MatDialog);

  constructor(private readonly loadingSpinnerService: LoadingSpinnerService) {
  }

  open(modalComponent: ComponentType<any>, matDialogConfig: MatDialogConfig): MatDialogRef<any> {
    if (this.dialog.openDialogs.length > 0) {
      this.close();
    }
    return this.dialog.open(modalComponent, matDialogConfig);
  }

  openExceptionDialog(matDialogConfig: MatDialogConfig): MatDialogRef<any> {
    this.loadingSpinnerService.hide();
    matDialogConfig.data.title ??= 'exceptions.fallback.modal.subject';
    matDialogConfig.data.message ??= 'exceptions.fallback.modal.body';
    return this.open(ExceptionDialogComponent, matDialogConfig);
  }

  close(): void {
    this.dialog.closeAll();
  }
}
